import { ORDERED_WEEK_DAYS } from "../enums/week-days.enum";
import { SchedulerDayConfigModel } from "./scheduler-day-config.model";
import { InstallationType } from "./installation-type.type";

export class SchedulerConfigModel {
    monday?: SchedulerDayConfigModel;
    tuesday?: SchedulerDayConfigModel;
    wednesday?: SchedulerDayConfigModel;
    thursday?: SchedulerDayConfigModel;
    friday?: SchedulerDayConfigModel;
    saturday?: SchedulerDayConfigModel;
    sunday?: SchedulerDayConfigModel;
    // snake_case to match the installation_type wire contract read by almabox-launcher.
    installation_type?: InstallationType;

    constructor() {
        for (const day of ORDERED_WEEK_DAYS) {
            this[day] = {
                schedule: [],
                birthday: undefined
            }
        }
    }
}